import type { QueryClient } from "@tanstack/react-query";
import type { PracticeRecord } from "@pushback-and-chaos/contracts";

/**
 * WHETHER THE SETTINGS SHEET MAY OFFER THE COACH'S-DATA CONTROLS (Law 5;
 * 2026-10-11). On the record's word for a CONFIRMED profile, never on the
 * stored profile id: that id is written the moment the intake has a draft,
 * before the learner has confirmed the read-back, and at that moment "remove
 * it all." would remove the intake from under the read-back. While the
 * record has not answered, nothing is offered.
 */
export function coachDataOffered(record: PracticeRecord | undefined): boolean {
  return record !== undefined && record.profile !== null;
}

/**
 * WHAT THIS BROWSER'S CACHE FORGETS AFTER A REMOVAL (2026-10-11). The arrival
 * book is REMOVED, not invalidated: an invalidated query keeps its last answer
 * while the refetch is out, and TanStack keeps data on an error, so the
 * record's row went on drawing a book the server had just said does not exist
 * (404). The intake query is invalidated with the coach's surfaces, so a
 * learner whose profile went with the removal is asked again rather than
 * shown the old draft.
 */
export async function afterCoachDataRemoved(queryClient: QueryClient): Promise<void> {
  queryClient.removeQueries({ queryKey: ["arrival"] });
  await Promise.all(["coachThread", "coachOpening", "practice", "focus", "profileIntake"].map((key) => queryClient.invalidateQueries({ queryKey: [key] })));
}
